import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchSubLeaveTypeData = createAsyncThunk("fetchSubLeaveTypeData", async (token) => {

  const getsubLeaveType = CryptoJS.SHA256("/getsubLeaveType" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  const response = await fetch(
    `${env.backend_api_endpoint}/${getsubLeaveType}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    }
  );
  const resData = await response.json();

  if (resData?.data) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.data = JSON.parse(decrypted); // ✅ replace encrypted data with decrypted JSON
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  // ✅ Return the full response (status, message, and decrypted data)
  return resData;
});

const subLeaveTypeDataSlice = createSlice({
  name: "getSubLeaveType",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSubLeaveTypeData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSubLeaveTypeData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchSubLeaveTypeData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default subLeaveTypeDataSlice.reducer;
